import { createContext, useContext, useState } from 'react';
import CryptoJS from 'crypto-js';
import { efefrg4rrrg323ffgfssw3e3ddadfw23 } from '../components/componentConst';
import { createTheme } from '@mui/material/styles';
import SavingsIcon from '@mui/icons-material/Savings';
import CalculateIcon from '@mui/icons-material/Calculate';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';

const AuthContext = createContext();

const SECRET_KEY = efefrg4rrrg323ffgfssw3e3ddadfw23;

// Helper functions for encryption and decryption
const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error('Error decrypting data:', error);
    return null;
  }
};
// --- MERGED THEME DEFINITION ---
export const getAppTheme = (mode = 'light') => {
  mode = "light"
  const headingFont = '"Plus Jakarta Sans", sans-serif';
  const bodyFont = '"Inter", sans-serif';
  return createTheme({
    palette: {
      mode,
      primary: { main: '#093159' },
      secondary: { main: mode === 'dark' ? '#ffc107' : '#3f51b5' },
      dark: { main: '#111111' },
      light: { main: '#ffffff' },
      present: { main: '#4CAF50' },
      absent: { main: '#F44336' },
      leave: { main: '#FF9800' },
      background: {
        default: mode === 'dark' ? '#14141a' : '#ecebed',
        paper: mode === 'dark' ? '#1c1b1b' : '#ffffff',
        accent: mode === 'dark' ? '#2d2d35' : '#f5f5f7',
      },
      color: {
        default: mode === 'dark' ? '#ffffff' : '#121212',
        paper: mode === 'dark' ? '#ffffff' : '#1b1b1b',
        muted: mode === 'dark' ? '#a0a0a0' : '#6e6e73',
      },
      text: {
        primary: mode === 'dark' ? '#e0e0e0' : '#212529',
        secondary: mode === 'dark' ? '#a0a0a0' : '#6c757d',
      },
      heading: {
        h6: mode === 'dark' ? "#b8b8f5" : "#36366b",
        h2: mode === 'dark' ? "#b8b8f5" : "#36366b"
      },
      input: {
        background: mode === 'dark' ? '#2d2d35' : '#ffffff',
        text: mode === 'dark' ? '#ffffff' : '#000000',
        border: mode === 'dark' ? '#404040' : '#e0e0e0',
        placeholder: mode === 'dark' ? '#8e8e93' : '#86868b'
      }
    },
    typography: {
      // ✅ CHANGE THIS LINE
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',

      typography: {
        fontFamily: bodyFont, // Default font is Inter
        h1: { fontFamily: headingFont, fontWeight: 800 },
        h2: { fontFamily: headingFont, fontWeight: 800 },
        h3: { fontFamily: headingFont, fontWeight: 800 },
        h4: { fontFamily: headingFont, fontWeight: 700 },
        h5: { fontFamily: headingFont, fontWeight: 700 },
        h6: { fontFamily: headingFont, fontWeight: 700 },
        body1: { fontWeight: 400 },
        body2: { fontWeight: 400 },
      },
    },
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            '& .MuiTableCell-head': {
              fontWeight: 'bold',
              fontSize: '1rem',
              color: 'white',
            }
          }
        }
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            backgroundColor: 'inherit',
          }
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              backgroundColor: mode === 'dark' ? '#2d2d35' : '#ffffff',
              '& fieldset': {
                borderColor: mode === 'dark' ? '#404040' : '#e0e0e0',
              },
              '&:hover fieldset': {
                borderColor: mode === 'dark' ? '#606060' : '#bdbdbd',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5c97c3',
              },
            },
            '& .MuiInputLabel-root': {
              color: mode === 'dark' ? '#8e8e93' : '#86868b',
            },
            '& .MuiOutlinedInput-input': {
              color: mode === 'dark' ? '#ffffff' : '#000000',
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: '8px',
            fontWeight: 600,
            padding: '8px 24px',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              transition: 'all 0.3s ease',
            },
          },
          contained: {
            backgroundColor: '#5c97c3',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#4a85b1',
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
            boxShadow: mode === 'dark'
              ? '0 4px 20px rgba(0,0,0,0.5)'
              : '0 4px 20px rgba(0,0,0,0.1)',
            border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
            transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: mode === 'dark'
                ? '0 12px 40px rgba(0,0,0,0.3)'
                : '0 12px 40px rgba(92,151,195,0.2)',
              borderColor: '#5c97c3'
            }
          },
        },
      }
    }
  });
};

export const sidebarContent = (loginStatus = []) => {
  return [
    {
      title: "Fixed Deposit Features",
      cardConfig: [
        {
          link: '/',
          icon: <HomeIcon />,
          colorOne: [7, 60, 77],
          colorTwo: [7, 60, 77],
          text: 'Home',
        },
        {
          link: '/fd-marketplace',
          icon: <SavingsIcon />,
          colorOne: [20, 90, 50],
          colorTwo: [20, 90, 50],
          text: 'FD Marketplace',
        },
        {
          link: '/fd-calculator',
          icon: <CalculateIcon />,
          colorOne: [10, 40, 70],
          colorTwo: [10, 40, 70],
          text: 'FD Calculator',
        },
        {
          link: '/fd-booking',
          icon: <TaskAltIcon />,
          colorOne: [100, 20, 80],
          colorTwo: [100, 20, 80],
          text: 'Book FD',
        },
        {
          link: '/kyc-verification',
          icon: <VerifiedUserIcon />,
          colorOne: [0, 123, 255],
          colorTwo: [0, 123, 255],
          text: 'KYC Verification',
        },
        {
          link: '/fd-documents',
          icon: <UploadFileIcon />,
          colorOne: [153, 102, 255],
          colorTwo: [102, 51, 255],
          text: 'Upload Docs',
        },
        {
          link: '/fd-track',
          icon: <SearchIcon />,
          colorOne: [255, 153, 51],
          colorTwo: [204, 102, 0],
          text: 'Track FDs',
        },
      ],
    },
  ];
};

export const AuthProvider = ({ children }) => {
  const [loginStatus, setLoginStatus] = useState(() => {
    const encryptedCreds = localStorage.getItem('loginCred');
    if (encryptedCreds) {
      const decryptedData = decryptData(encryptedCreds);
      return decryptedData || {}; // Return decrypted data or fallback to an empty object
    }
    return {};
  });

  const saveLoginStatus = (data) => {
    const encryptedData = encryptData(data);
    localStorage.setItem('loginCred', encryptedData); // Save encrypted data in localStorage
    setLoginStatus(data); // Update the context with actual data
  };

  const clearLoginStatus = () => {
    localStorage.removeItem('loginCred');
    setLoginStatus({});
  };

  return (
    <AuthContext.Provider value={{ loginStatus, saveLoginStatus, clearLoginStatus }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
